import React, { useState } from 'react';
import {
  LeftAdmin,
  TopLeftAdmin,
  BottomLeftAdmin,
  AdminContainer,
  RightAdmin,
  AdminTable,
} from '../../AdminRoutes/Admin/AdminStyles.styles';
import AuthCheckManager from '../../Utils/AuthCheck/ManagerCheck.auth';
import Auth from '../../Helpers/auth';
import CompanyHomeDataProvider from '../../Utils/Companies/CompanyHomeDataProvider';
import CompanyTabsComponent from '../CompanyTabs/CompanyTabs.component';
import EmployeesTab from '../CompanyTabs/Employees/EmployeesTab.component';
import CompanySideMenu from './CompanySideMenu.component';
import FormsTab from '../CompanyTabs/Forms/FormsTab.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import { useMediaQuery } from 'react-responsive';

const CompanyHome = () => {
  const [showEmployees, setShowEmployees] = useState(true);
  const [showForms, setShowForms] = useState(false);
  const { data } = Auth.getProfile();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    <AuthCheckManager>
      <>
        <HelmetHelper title="Company Home" description="Company Home Page" />
        <CompanyHomeDataProvider id={data?.id}>
          {(company) => (
            <AdminContainer>
              <LeftAdmin>
                <TopLeftAdmin>
                  <h2>
                    {company?.company?.companyName
                      ? `${company?.company?.companyName} Dashboard`
                      : 'Company Dashboard'}
                  </h2>
                </TopLeftAdmin>
                <BottomLeftAdmin>
                  <CompanySideMenu Auth={Auth} id={company?.company?._id} />
                </BottomLeftAdmin>
              </LeftAdmin>
              {!isMobile && (
                <RightAdmin>
                  <CompanyTabsComponent
                    showEmployees={showEmployees}
                    setShowEmployees={setShowEmployees}
                    showForms={showForms}
                    setShowForms={setShowForms}
                  />
                  <AdminTable>
                    {showEmployees && (
                      <EmployeesTab
                        alerts={company?.alerts}
                        companyId={company?.company?._id}
                      />
                    )}
                    {showForms && (
                      <FormsTab
                        forms={company?.company?.forms}
                        companyId={company?.company?._id}
                      />
                    )}
                  </AdminTable>
                </RightAdmin>
              )}
            </AdminContainer>
          )}
        </CompanyHomeDataProvider>
      </>
    </AuthCheckManager>
  );
};

export default CompanyHome;
